import React, { useEffect, useState } from "react";
import { GatsbyImage } from "gatsby-plugin-image";
import Marquee from "react-fast-marquee";

const Brands = ({ brands }) => {
  const [activeBrand, setActiveBrand] = useState(0);
  useEffect(() => {
    const interval = setInterval(() => {
      if (activeBrand === brands.length - 1) {
        setActiveBrand(0);
      } else {
        setActiveBrand(activeBrand + 1);
      }
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="w-full h-48 sm:h-[228px] bg-light-purple overflow-hidden">
      <p className="text-3xl italic text-center py-2 text-black">as seen in:</p>
      <div className="hidden sm:flex items-center h-40">
        <Marquee
          speed={100}
          gradient={false}
          className="w-full display-override sm:display-normal "
        >
          {brands.map((brand, index) => (
            <div
              className="min-w-[250px] sm:w1/2 md:w-1/3 lg:w-1/4 flex items-center justify-center"
              key={index}
            >
              <GatsbyImage
                image={brand.asset.gatsbyImageData}
                alt={brand.asset.filename}
                objectFit="contain"
                className="max-w-[165px] w-full h-min max-h-[90px]"
              />
            </div>
          ))}
        </Marquee>
      </div>
      <div className="flex relative mt-2 sm:hidden">
        {brands.map((brand, index) => (
          <div
            key={index}
            className={`${
              activeBrand === index ? "opacity-100" : "opacity-0"
            } w-[141px] absolute inset-0 mx-auto h-[90px] flex items-center justify-center sm:hidden transform transition-opacity duration-500 ease-linear`}
          >
            <GatsbyImage
              image={brand.asset.gatsbyImageData}
              alt={brand.asset.filename}
              objectFit="contain"
              className="w-full h-fit"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Brands;
